import { useEffect, useState } from 'react';
import { useFetchCallback } from '@services/services';
import toast from 'react-hot-toast';
import { Announcement } from '@interfaces/general';

interface AnnouncementFilter {
  date: string;
  plan: string;
}

export const useGetAnnouncement = (filter: AnnouncementFilter) => {
  const [announcement, setAnnouncement] = useState<Announcement | undefined>();

  const { isFetching, call } = useFetchCallback<
    undefined,
    {
      results: Announcement[];
    }
  >('get', '', 'v2');

  const fetchAnnouncement = async () => {
    if (filter.plan === 'desconocido') {
      return undefined;
    }
    try {
      const fullUrl = `announcements?date=${filter.date}&plan=${filter.plan}&page_size=1&is_active=true&announcement_type=modal`;
      const response = await call({ path: fullUrl });
      if (response) {
        const [firstResult] = response.results;
        setAnnouncement(firstResult);
      }
    } catch {
      toast.error('Error al obtener los anuncios filtrados');
    }
  };

  useEffect(() => {
    fetchAnnouncement();
  }, [filter.date, filter.plan]);

  return {
    announcement,
    isFetching,
    fetchAnnouncement,
  };
};
